<template>
  <div id="home_wrap" class="home_wrap">
    
    <!-- ================= 顶部导航 ================= -->
    <div class="red_top_bg">
      <div class="home-logo">
        <img v-if="version && version.logo" :src="version.logo" alt="logo">
        <span class="app_name">{{ version ? version.name : 'MD' }}</span>
      </div>
      <div class="header_right">
        <!-- 地球/语言切换图标 -->
        <div class="lang_icon" @click="goToLanguage">
         <img :src="require('../img/user/language.png')" alt=""  style="width: 24px;height: 24px;;">
		 </div>
      </div>
    </div>
	<!-- 3. 用户资产白色大卡片 -->
	<div class="card_box user_asset_box">
	  <div class="welcome_text">{{ $t('utils.msg3') }} {{ version ? version.name : 'MD' }}</div>
	  <div class="user_name">
	    <span class="hand_emoji">👋</span> Hi, ceshi001
	  </div>
	  
	  <div class="asset_title">{{ $t('utils.msg4') }}</div>
	  <div class="asset_money">{{ common.currency_symbol_basic() }}{{ common.precision_basic(money_r+fundBalanceUsd) }}</div>
	  
	  <!-- 资产子项四宫格 -->
	  <div class="asset_grid">
	    <div class="asset_item">
	      <div class="item_label">{{ $t('utils.lunlog43') }}</div>
	      <div class="item_val green">{{ common.currency_symbol_basic() }}{{ common.precision_basic(fundBalanceUsd) }}</div>
	    </div>
	    <div class="asset_item">
	      <div class="item_label">{{ $t('utils.lunlog42') }}</div>
	      <div class="item_val black">{{ common.currency_symbol_basic() }}{{ common.precision_basic(money_r) }}</div>
	    </div>
	    <div class="asset_item">
	      <div class="item_label">{{ $t('utils.msg5') }}</div>
	      <div class="item_val blue">{{ common.currency_symbol_basic() }}{{ common.precision_basic(data.invest_money) }}</div>
	    </div>
	    <div class="asset_item">
	      <div class="item_label">{{ $t('utils.msg6') }}</div>
	      <div class="item_val orange">{{ common.currency_symbol_basic() }}{{ common.precision_basic(data.wait_interest) }}</div>
	    </div>
	  </div>
	</div>
    <!-- ================= 主体内容 ================= -->
    <div class="main_content">
      
      <!-- 1. 轮播图 (自动横向轮播) -->
      <div class="swiper_container" v-if="banners && banners.length > 0">
        <van-swipe :autoplay="3000" class="my-swipe" indicator-color="white">
          <van-swipe-item v-for="(image, index) in banners" :key="index" @click="jump(image.url)">
            <img :src="image.img" class="banner_img" alt="banner">
          </van-swipe-item>
        </van-swipe>
      </div>
	<div class="quick_menu_title">{{ $t('utils.msg7') }}</div>
	<div class="card_box quick_menu_box">
	  <div class="menu_grid">
		  
		  
	    <div class="menu_item" @click="$router.push('/recharge')">
	      <div class="menu_icon">
	        <img :src="require('../img/index/receive.png')" alt="">
	      </div>
	      <div class="menu_name">{{ $t('user.recharge') }}</div>
	    </div>
		<div class="menu_item" @click="$router.push('/withdraw')">
		  <div class="menu_icon">
		    <img :src="require('../img/index/send.png')" alt="">
		  </div>
		  <div class="menu_name">{{ $t('user.withdraw') }}</div>
		</div>
		<div class="menu_item"  @click="openService">
		  <div class="menu_icon">
		    <img :src="require('../img/user/kf.png')" alt="">
		  </div>
		  <div class="menu_name">{{ $t('user.onlineService') }}</div>
		</div>
		<div class="menu_item"   @click="$router.push('/article/16')">
		  <div class="menu_icon">
		    <img :src="require('../img/index/gs.png')" alt="">
		  </div>
		  <div class="menu_name"> {{ $t('utils.gs') }}</div>
		</div>
		<div class="menu_item"  @click="$router.push('/questions')">
		  <div class="menu_icon">
		    <img :src="require('../img/user/question.png')" alt="">
		  </div>
		  <div class="menu_name">{{ $t('user.faq') }}</div>
		</div>
		<div class="menu_item"@click="$router.push('/kode')">
		  <div class="menu_icon">
		    <img :src="require('../img/index/lp.jpg')" alt="">
		  </div>
		  <div class="menu_name">{{ $t('utils.kcode') }}</div>
		</div>
	  </div>
	</div>

      <!-- 2. 动态滚动新闻 (垂直无限滚动) -->
    <div class="currency_tips" v-if="new_list && new_list.length > 0">
           <van-swipe style="height: 40px;" :autoplay="2500" vertical :show-indicators="false">
             <van-swipe-item v-for="(item,index) in new_list" :key="index" @click="$router.push('article/'+item.id)">
               <div class="currency_detail">
                 <div style="display:flex; align-items:center; width: 100%; height: 40px; padding-left: 10px;">
                   <img v-if="item.img" :src="item.img" style="width: 30px; height: 30px; border-radius: 5px; margin-right: 8px;">
                   <div style="flex:1; font-size: 13px; color: #333; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                     {{ item.title }}
                   </div>
                 </div>
               </div>
             </van-swipe-item>
           </van-swipe>
         </div>
      


      <!-- 5. 快捷菜单 -->
      

      <!-- 6. 推荐项目 (黄金基金) -->
      <div class="section_header">
        <span class="title">{{ $t('index.recommendedItem') }}</span>
        <span class="view_all" @click="$router.push('/invest')">View All →</span>
      </div>

      <div class="card_box project_card" v-for="(item,index) in items" :key="index" >
        <div class="project_top">
          <div class="proj_img">
            <img :src="item.img2 " alt="Gold" >
          </div>
          <div class="proj_info">
            <div class="proj_title">{{item.title}}</div>
            <div class="proj_tags">
              <span class="tag vip">{{item.level_name}}</span>
              <span class="tag auto"> {{ $t('utils.lunlog50') }}</span>
              <span class="tag safe"> {{ $t('utils.lunlog49') }}</span>
            </div>
          </div>
        </div>

        <div class="proj_data_grid">
          <div class="data_item">
            <div class="data_val">{{ common.currency_symbol_basic() }}{{item.newmin}}</div>
            <div class="data_label">{{ $t('index.amount') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val">{{ common.currency_symbol_basic() }}{{item.fan}}</div>
            <div class="data_label">{{ $t('utils.lunlog31') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val" v-if="item.type==3">
				{{item.day}}{{$t('index.hour')}}
			</div>
			<div class="data_val" v-else>
				{{item.day}}{{$t('index.day')}}
			</div>
            <div class="data_label">{{ $t('index.cycle') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val blue">{{item.rate}}%</div>
            <div class="data_label">{{ $t('index.rate') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val">{{ common.currency_symbol_basic() }}{{item.days}}/{{$t('index.day')}}</div>
            <div class="data_label">{{ $t('invest.income') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val black">{{ common.currency_symbol_basic() }}{{item.zong}}</div>
            <div class="data_label"> {{ $t('utils.goodszong') }}</div>
          </div>
        </div>

        <div class="project_btn" @click="$router.push('/invest/detail/'+item.id)">
          {{ $t('utils.lunlog29') }}
        </div>
      </div>
      
      <div style="height: 60px;"></div>
    </div>

    <!-- 弹窗保持原有逻辑 -->
    <van-dialog v-model="show_tc" :confirm-button-text="$t('utils.confirm')">
      <div class="popup" v-html="tc_content" />
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { openUrl } from '../../utils/openUrl';
import { Swipe, SwipeItem, Dialog, Popup, Lazyload } from "vant";
import { openServiceUrl } from "../../utils/openUrl";

Vue.use(Dialog).use(Popup).use(Lazyload);

export default {
  name: "Index",
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
  },
  data() {
    return {
      logo: localStorage.getItem("logo2"),
      banners: [],
      version: {},
      show_tc: false,
	  items:[],
      kefu: '',
      tc_content: "",
      new_list: [], // 新增：滚动新闻数据
	  data: {},
	  fundBalance: 0.00,
	  fundBalanceUsd: 0.00,
	  money_r:0.00,
	  savings: 0.00,
	  eye: 1,
	  service:'',
	  signinStatue:false,
      // 快捷菜单数据
      quickMenus: [
        { name: this.$t('user.recharge'), icon: require('../img/index/receive.png'), url: '/recharge' },
        { name: this.$t('user.withdraw'), icon: require('../img/index/send.png'), url: '/withdraw' },
        { name: this.$t('user.onlineService'), icon: require('../img/user/kf.png'), url: '' },
        { name: this.$t('utils.gs'), icon: require('../img/user/gs.png'), url: '/article/16' },
        { name: this.$t('user.faq'), icon: require('../img/user/question.png'), url: '/questions' },
        { name: this.$t('utils.kcode'), icon: require('../img/index/lp.jpg'), url: '/kode' },
      ]
    };
  },
  created() {
    if (window.plus) {
      window.plus.navigator.setStatusBarBackground('#FFFFFF');
      window.plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('index');
  },
  mounted() {
    this.start();
  },
  methods: {
    jump(url) {
      if(url) openUrl(url, this.$router);
    },
    goToLanguage() {
      this.$router.push('/language');
    },
	openService() {
		openServiceUrl(this.kefu, this.$router);
	},
    start() {
	  var isapp = 0;
	  if (window.plus) {
	  	isapp = 1;
	  }
	  Fetch('/user/info', {
	  	isapp: isapp
	  }).then((r) => {
	  	this.data = r.data;
	  	this.fundBalance = r.data.fundBalance;
	  	this.fundBalanceUsd = r.data.fundBalanceUsd;
	  	this.money_r = r.data.money_r;
	  	this.menus1[0]['value'] = r.data.vip_name;
	  	this.currency = r.data.currency;
	  	this.signinStatue = r.data.signin;
	  	this.service = r.data.service;
	  });
      Fetch('/index/int').then((r) => {
        // 1. 弹出框逻辑
        if (r.data.popup.show == 1) {
          let popup_show = sessionStorage.getItem("popup_show");
          sessionStorage.setItem("popup_show", r.data.popup.num);
          if (popup_show == null || popup_show != 1) {
            this.tc_content = r.data.popup.content;
            this.show_tc = true;
          }
        }
        
        // 2. 核心数据赋值 (解决数据显示不出问题)
        this.banners = r.data.banner || [];
		this.items=r.data.items || []; 
        this.version = r.data.version || {};
        this.new_list = r.data.new_list || []; 
        this.kefu = r.data.service ? r.data.service.kefu : '';
        
        // 3. 其他可选的数据更新
        // this.quickMenus = r.data.menus; // 如果后台有下发菜单，解开注释
        // this.projects = r.data.projects; // 如果后台有下发投资项目，解开注释
      });
    }
  }
};
</script>

<style lang="less" scoped>
/* 全局基础 */
.home_wrap {
  min-height: 100vh;
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
  padding-top: 60px;
  padding-bottom: 80px;
}

/* 顶部导航 */
.red_top_bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  
  .home-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    img { height: 32px; object-fit: contain; }
    .app_name { font-size: 20px; font-weight: 700; color: #000; }
  }
  
  .header_right {
    display: flex;
    align-items: center;
    .lang_icon {
      padding: 6px;
      border-radius: 50%;
      background: #f5f5f5;
      cursor: pointer;
      svg { display: block; }
    }
  }
}

/* 轮播图样式 */
.swiper_container {
  margin-bottom: 10px;
  border-radius: 18px;
  width: 95%;
  margin: 0 auto;
  overflow: hidden;
}
.my-swipe {
  width: 100%;
  height: 160px;
  .van-swipe-item {
    width: 100%;
    height: 100%;
    img.banner_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

/* 动态滚动新闻样式 */
.currency_tips {
  margin-bottom: 12px;
  background: #fff;
  border-radius: 18px;
  border: 1px solid rgba(176, 202, 240, 0.3);
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(24, 61, 122, 0.04);
}
.currency_detail {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 10px;
}

/* 主体内容容器 */
.main_content {
  padding: 12px 5px;
}

/* 通用白色圆角卡片 */
.card_box {
  background: #ffffff;
  width: 95%;
  margin: 0  auto;
  border-radius: 18px;
  padding: 20px 16px;
  box-shadow: 0 4px 16px rgba(24, 61, 122, 0.08);
  margin-bottom: 16px;
  margin-top: 10px;
  border: 1px solid rgba(176, 202, 240, 0.3);
}

/* 1. 用户资产大卡片 */
.user_asset_box {
  .welcome_text { font-size: 14px; color: #333; margin-bottom: 4px; }
  .user_name {
    font-size: 18px; font-weight: 700; color: #111;
    .hand_emoji { margin-right: 4px; }
  }
  .asset_title { font-size: 12px; color: #888; margin-top: 12px; }
  .asset_money { font-size: 18px; font-weight: 800; color: #000; margin-bottom: 16px;line-height: 32px;}
  
  .asset_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    
    .asset_item {
      background: #f8faff;
      border-radius: 10px;
      padding: 12px 0;
      text-align: center;
      .item_label { font-size: 12px; color: #666; margin-bottom: 6px; }
      .item_val { font-size: 14px; font-weight: 700; }
      .green { color: #16a34a; }
      .black { color: #000; }
      .blue { color: #1d4ed8; }
      .orange { color: #d97706; }
    }
  }
}

/* 2. 宣传 Banner */
.promo_banner {
  padding: 0;
  overflow: hidden;
  .banner_img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 18px;
  }
}

/* 3. 快捷菜单 */
.quick_menu_title {
  font-size: 16px; font-weight: 700; color: #111; margin-bottom: 12px; margin-top: 14px;margin-left: 10px
}
.quick_menu_box {
  padding: 16px 10px;
  .menu_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 20px;
    .menu_item {
      display: flex; flex-direction: column; align-items: center; cursor: pointer;
      .menu_icon {
        width: 44px; height: 44px; background: #f5f8ff; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 8px;
        img { width: 24px; height: 24px; object-fit: contain; }
      }
      .menu_name { font-size: 13px; font-weight: 500; color: #333; }
    }
  }
}

/* 4. 推荐项目标题 */
.section_header {
  display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; margin-top: 4px;
  .title { font-size: 16px; font-weight: 700; color: #111; padding: 0 10px;}
  .view_all { font-size: 13px; color: #2563eb; cursor: pointer; }
}

/* 5. 投资产品卡片 */
.project_card {
  .project_top {
    display: flex; gap: 12px; margin-bottom: 16px;
    .proj_img {
      width: 80px; height: 80px; border-radius: 12px; overflow: hidden; flex-shrink: 0;
      img { width: 100%; height: 100%; object-fit: cover; }
    }
    .proj_info {
      flex: 1; display: flex; flex-direction: column; justify-content: center;
      .proj_title { font-size: 15px; font-weight: 700; color: #000; margin-bottom: 8px; }
      .proj_tags {
        display: flex; flex-wrap: wrap; gap: 6px;
        .tag {
          display: inline-flex; align-items: center; gap: 3px; background: #fff8e7; color: #b45309; font-size: 11px; padding: 3px 8px; border-radius: 12px;
          .icon { font-size: 12px; }
          &.vip { background: #fef3c7; }
          &.auto { background: #d1fae5; color: #047857; }
          &.safe { background: #fef3c7; }
        }
      }
    }
  }

  .proj_data_grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 16px;
    .data_item {
      background: #f6f9ff; border-radius: 8px; padding: 10px 0; text-align: center;
      .data_val { font-size: 14px; font-weight: 700; color: #000; margin-bottom: 4px; &.blue { color: #1d4ed8; } &.black { color: #333; } }
      .data_label { font-size: 12px; color: #777; }
    }
  }

  .project_btn {
    width: 100%; height: 44px; background: #2563eb; color: #fff; font-weight: 700; font-size: 16px; display: flex; justify-content: center; align-items: center; border-radius: 12px; cursor: pointer; transition: opacity 0.2s;
    &:active { opacity: 0.8; }
  }
}

.popup {
  max-height: 60vh; padding: 26px 24px; overflow-y: auto; font-size: 14px; line-height: 20px;
}
</style>